import { Search } from "lucide-react";
import { useState } from "react";

import { getNewsListUser } from "context/actions/news";

const HeroSection = ({ covers }) => {
  const [trackingNumber, setTrackingNumber] = useState("");
  const [data, setData] = useState([]);
  const [check, setCheck] = useState(0);

  const handleTrack = async () => {
    if (!trackingNumber.trim()) {
      alert("Утас эсвэл трак код оо оруулна уу"); // empty input check
      return;
    }
    await getInitData();
    setCheck(1); // tracked successfully
  };

  const getInitData = async () => {
    try {
      const res = await getNewsListUser(trackingNumber, 1); // use trackingNumber
      if (res.status === "success") {
        setData(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  console.log(data);

  const heroImage =
    covers?.[0]?.image?.thumbnail || covers?.[0]?.image?.path || "222.jpg";

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Cargo ship at port with containers"
          className="w-full h-full object-cover object-bottom"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-cargo-navy/30 to-cargo-navy/60" />
      </div>

      <div className="relative container mx-auto px-4 py-20 md:py-32">
        <div className="max-w-2xl mx-auto text-center animate-fade-up">
          <h1 className="text-3xl md:text-4xl font-extrabold text-primary-foreground mb-6 leading-tight">
            Бид БНХАУ – Баян-Өлгий чиглэлд таны ачааг хурдан шуурхай,
            найдвартайгаар тээвэрлэнэ.
          </h1>
        </div>
      </div>

      <div className="relative -mt-10 pb-8">
        <div className="container mx-auto px-4">
          <div className="max-w-xl mx-auto card-elevated p-6 animate-fade-up delay-200">
            <label className="block text-sm font-medium text-muted-foreground mb-2">
              Утас эсвэл трак код оо оруулна уу
            </label>
            <div className="flex gap-3">
              <input
                type="text"
                placeholder="Жишээ: 99001234"
                value={trackingNumber}
                onChange={(e) => setTrackingNumber(e.target.value)}
                className="input-field flex-1"
              />
              <button
                onClick={handleTrack}
                className="btn-primary flex items-center gap-2"
              >
                <Search className="w-5 h-5" />
                <span className="hidden sm:inline">Илгээмж шалгах</span>
              </button>
            </div>

            {/* Data display */}
            {check === 1 && data.length > 0 && (
              <div className="mt-4 space-y-4">
                {data.map((item, index) => (
                  <div
                    key={index}
                    className="p-4 rounded-lg shadow-sm border border-border bg-white transition hover:shadow-md"
                  >
                    <h3 className="text-lg font-semibold text-foreground mb-1">
                      {item.name}
                    </h3>
                    <div className="flex flex-col font-semibold sm:flex-row sm:justify-between gap-2 text-sm text-muted-foreground">
                      {item.location === "Ачигдсан" ? (
                        ""
                      ) : (
                        <span>📞 Утас: {item.phone}</span>
                      )}
                      <span>
                        📍 Байршил:{" "}
                        {item.location === "Монголд"
                          ? item.branchName
                          : item.location}
                      </span>

                      <span>💰 Үнэ: {item.price}₮</span>
                    </div>
                    <div className="flex sm:justify-end mt-2 ">
                      <span className="font-semibold text-sm text-muted-foreground">
                        Огноо:{" "}
                        {new Date(item.createdAt).toISOString().split("T")[0]}
                      </span>
                    </div>
                  </div>
                ))}
                <br />

                <div className="mt-4 p-4 rounded-lg bg-gray-50 text-center font-semibold text-base text-foreground shadow-sm">
                  {(() => {
                    const totalPrice = data.reduce(
                      (sum, i) => sum + Number(i.price || 0),
                      0
                    );
                    let discountRate = 0;
                    if (totalPrice >= 100_000) {
                      discountRate = 0.05;
                    }

                    const discount = totalPrice * discountRate;
                    const payable = totalPrice - discount;

                    const formatMoney = (n) =>
                      n.toLocaleString("en-US", { maximumFractionDigits: 0 });

                    return totalPrice >= 100_000 ? (
                      <>
                        🧾 Нийт үнэ: {formatMoney(totalPrice)}₮ <br />
                      </>
                    ) : (
                      <span>🧾 Нийт үнэ: {formatMoney(totalPrice)}₮</span>
                    );
                  })()}
                </div>
              </div>
            )}

            {check === 1 && data.length === 0 && (
              <div className="mt-4 text-sm text-muted-foreground">
                Илгээмж олдсонгүй.
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
